var map = {
	"./akira-schmid.jpg": 800,
	"./alan-sahin.jpg": 375,
	"./alwa-alibi-alias-estelle-plss.jpg": 31,
	"./ana-kohler.jpg": 283,
	"./angel-okaside.jpg": 161,
	"./benjamin-pittet.jpg": 896,
	"./ccile-bessire.jpg": 739,
	"./ditaji-kambundji.jpg": 436,
	"./dominic-stricker.jpg": 780,
	"./elias-regsegger.jpg": 953,
	"./elisabeth-dubler.jpg": 81,
	"./fabian-rieder.jpg": 972,
	"./fabian-staudenmann.jpg": 903,
	"./fiore-despina-streit.jpg": 715,
	"./freddy-hunziker.jpg": 776,
	"./laurenzia-karrer.jpg": 738,
	"./lucky-wthrich.jpg": 701,
	"./mardoch-kabengele.jpg": 632,
	"./mitra-gultom.jpg": 909,
	"./nina-schwarz.jpg": 722,
	"./nora-steiner.jpg": 332,
	"./rahel-freiburghaus.jpg": 61,
	"./salome-gruchola.jpg": 144,
	"./sebastian-beetschen.jpg": 713,
	"./simona-aebersold.jpg": 832,
	"./stphanie-zosso.jpg": 224,
	"./thomas-zaugg.jpg": 586,
	"./ti-kuhn.jpg": 263,
	"./tobias-frehner.jpg": 570,
	"./wintana-alemtsegay.jpg": 90
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 208;